import { createContext, useContext, useEffect, useState } from "react";
import { getMe, login as apiLogin, setToken, clearToken, getToken } from "@/lib/apiClient";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null); // null = loading, false = guest, object = admin
  useEffect(() => {
    if (!getToken()) { setAdmin(false); return; }
    getMe().then(setAdmin).catch(() => { clearToken(); setAdmin(false); });
  }, []);

  const login = async (email, password) => {
    const { token, user } = await apiLogin(email, password);
    setToken(token);
    setAdmin(user);
    return user;
  };
  const logout = () => { clearToken(); setAdmin(false); };

  return <AuthContext.Provider value={{ admin, login, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
